// 驾驶台

let notchList = [
  "5D",
  "4D",
  "3D",
  "2D",
  "1D",
  "D",
  "N",
  "R",
  "1R",
  "2R",
  "3R",
  "5R",
]

let speedObj = {
  left_5D: "NavFullFront",
  left_4D: "FullFront",
  left_3D: "HalfFront",
  left_2D: "SlowFront",
  left_1D: "DeadSlowFront",
  left_D: "Stop",
  left_N: "Stop",
  left_R: "Stop",
  left_1R: "DeadSlowLater",
  left_2R: "SlowLater",
  left_3R: "HalfLater",
  left_5R: "FullLater",
}

let leftNotch = []
for (let i in notchList) {
  let key = "left_" + notchList[i]
  let json = {}
  json.spd = speedObj[key]
  json.value = window.$leftNotch[key]
  leftNotch.push(json)
}

let rightSpd = {
  right_5D: "NavFullFront",
  right_4D: "FullFront",
  right_3D: "HalfFront",
  right_2D: "SlowFront",
  right_1D: "DeadSlowFront",
  right_D: "Stop",
  right_N: "Stop",
  right_R: "Stop",
  right_1R: "DeadSlowLater",
  right_2R: "SlowLater",
  right_3R: "HalfLater",
  right_5R: "FullLater",
}
let rightNotch = []
for (let i in notchList) {
  let key = "right_" + notchList[i]
  let json = {}
  json.spd = rightSpd[key]
  json.value = window.$rightNotch[key]
  rightNotch.push(json)
}

console.log("cccccccccc", leftNotch, rightNotch)

// 记录档位值
let lastMatchedSpd = null

// 硬件转软件协议
function hardwareToSoft(id, value, type) {
  if (type !== 1) {
    // 车钟消息处理
    if (type === 5) {
      let data = notchToSoft(id, value)
      return data
    }
    return null
  }
}

// 车钟转软件协议
function notchToSoft(id, value) {
  // 确定要匹配的档位列表
  let notch = null

  if (id === 2) {
    notch = rightNotch
  }

  // 空值校验
  if (!notch || notch.length === 0) return null

  let matchedSpd = null

  // 遍历所有档位（从后到前，覆盖第一个档位）
  for (let i = notch.length - 1; i >= 0; i--) {
    const current = notch[i]
    // 核心逻辑：value ≤ 当前档位值 → 匹配该档位（越小越靠后）
    if (value <= current.value) {
      matchedSpd = current.spd
      break // 找到最靠后的匹配档位，退出循环
    }
  }

  // 兜底：如果没匹配到（value > 所有档位值），取第一个档位（5D）
  if (!matchedSpd) {
    matchedSpd = notch[0].spd
  }

  if (lastMatchedSpd === matchedSpd) {
    console.log(
      "🚀 ~ 1265.js:113 ~ 相同档位:",
      matchedSpd,
      lastMatchedSpd,
      value,
    )
    return null
  }

  // 更新
  lastMatchedSpd = matchedSpd
  console.log("🚀 ~ 1265.js:123 ~ 更新后不同档位:", matchedSpd, lastMatchedSpd, value)

  return { value: matchedSpd }
}

// function notchToSoft(id, value) {
//   let notch = null

//   if (id === 1) {
//     notch = leftNotch
//   }
//   if (id === 2) {
//     notch = rightNotch
//   }

//   if (!notch) {
//     return null
//   }

//   let spd = null
//   for (let i = 1; i < notch.length; i++) {
//     let beginVal = notch[i - 1]
//     let endVal = notch[i]
//     console.log("aaaaaaaaaa", beginVal, endVal, value)
//     if (beginVal.value >= value && endVal.value < value) {
//       spd = beginVal.spd
//     }
//   }
//   console.log("dddddddddd", id, value, spd)

//   if (spd === null) {
//     return null
//   }

//   let json = {}

//   json.value = spd

//   return json
// }

export default {
  hardwareToSoft,
}
